import { Box, InputGroup, Textarea } from '@chakra-ui/react';
import { FC } from 'react';
import { SmallHeading } from 'src/components/common/texts/SmallHeading/smallHeading';
import { Field } from 'formik';

interface Props {
	label?: string | null;
	placeholder: string;
	name: string;
}

export const TextareaField: FC<Props> = ({ label = null, placeholder, name }) => {
	return (
		<Box marginTop={label ? '8px' : '18px'}>
			{label && <SmallHeading text={label} />}
			<InputGroup
				marginTop="7px"
				borderRadius="6px"
				borderColor="#4E4F52"
			>
				<Field
					as={Textarea}
					name={name}
					padding="20px"
					bg="#111111"
					type="tel"
					placeholder={placeholder}
					fontSize="14px"
					_placeholder={{
						color: '#686868',
					}}
				/>
			</InputGroup>
		</Box>
	);
};
